// src/hooks/useApiError.ts
import { useState, useCallback } from 'react';
import axios from 'axios';
import { Alert } from '@mui/material';

export function useApiError() {
    const [error, setError] = useState<string | null>(null);

    const handleError = useCallback((err: unknown, fallbackMessage = 'Something went wrong.') => {
        let message = fallbackMessage;

        if (axios.isAxiosError(err)) {
            const data = err.response?.data as any;

            // Try common API error shapes
            message =
                data?.message ||
                data?.detail ||
                (typeof data === 'string' ? data : '') ||
                fallbackMessage;
        }

        setError(message);
        console.error(err);
    }, []);

    const clearError = useCallback(() => setError(null), []);

    const ErrorAlert = () =>
        error ? (
            <Alert
                severity="error"
                sx={{ mb: 2 }}
                onClose={clearError}
            >
                {error}
            </Alert>
        ) : null;

    return { error, handleError, clearError, ErrorAlert };
}
